/**
 * Product Card Swiper init — Ivonne
 * --------------------------------------------------------------
 * Inicializa Swiper sobre cada `.product-card__swiper` y lo
 * re-inicializa cuando el AJAX de Prestige (paginacion, facets,
 * sort) reemplaza el contenido de <product-list>.
 *
 * Notas:
 * - Idempotente: si un .product-card__swiper ya fue inicializado,
 *   no se vuelve a instanciar (evita memory leaks).
 * - El observer escucha addedNodes en todo <body> pero solo actua
 *   sobre nodos `.product-card__swiper`.
 * - Comportamiento por dispositivo (acuerdo con el equipo):
 *     desktop = hover + swipe (Swiper drag habilitado)
 *     mobile  = solo swipe (no hay hover en touch)
 *   Por eso no segmentamos por viewport: Swiper drag activo en
 *   ambos. El hover-swap viene de FigPii por CSS sobre las clases
 *   `.swiper-slide-active` / `.swiper-slide-prev` que pone Swiper.
 */
(function () {
  'use strict';

  var INIT_FLAG = 'swiperInitialized';

  function initSingleSwiper(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.dataset[INIT_FLAG] === 'true') return;
    if (typeof Swiper === 'undefined') return;

    new Swiper(el, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 1,
      pagination: {
        // Scope al card actual; si el snippet no tiene .swiper-pagination
        // (caso actual), el config es inerte y Swiper no falla.
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });

    el.dataset[INIT_FLAG] = 'true';
  }

  function initSwipersIn(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var nodes = scope.querySelectorAll('.product-card__swiper');
    for (var i = 0; i < nodes.length; i++) initSingleSwiper(nodes[i]);
  }

  // --- Pasada inicial -----------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSwipersIn(document);
    });
  } else {
    initSwipersIn(document);
  }

  // --- Re-init en cambios de DOM (paginacion/facets AJAX) -----------------
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.product-card__swiper')) {
          initSingleSwiper(node);
        }
        initSwipersIn(node);
      }
    }
  });

  function startObserving() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
})();
